/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './field-pair.component';
import * as import2 from '@angular/forms';
const styles_FieldPairComponent:any[] = ([] as any[]);
export const RenderType_FieldPairComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_FieldPairComponent,
  data: {}
}
);
export function View_FieldPairComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_FieldPairComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-field-pair',([] as any[]),(null as any),(null as any),(null as any),View_FieldPairComponent_0,RenderType_FieldPairComponent)),
    import0.ɵdid(49152,(null as any),0,import1.FieldPairComponent,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import1.FieldPairComponent])
  ]
  ,(null as any),(null as any));
}
export const FieldPairComponentNgFactory:import0.ComponentFactory<import1.FieldPairComponent> = import0.ɵccf('woa-field-pair',import1.FieldPairComponent,View_FieldPairComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvaW5wdXRzL2Zvcm0vZmllbGQtcGFpci9maWVsZC1wYWlyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL2lucHV0cy9mb3JtL2ZpZWxkLXBhaXIvZmllbGQtcGFpci5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL2lucHV0cy9mb3JtL2ZpZWxkLXBhaXIvZmllbGQtcGFpci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvaW5wdXRzL2Zvcm0vZmllbGQtcGFpci9maWVsZC1wYWlyLmNvbXBvbmVudC50cy5GaWVsZFBhaXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGVudD48L25nLWNvbnRlbnQ+XG4iLCI8d29hLWZpZWxkLXBhaXI+PC93b2EtZmllbGQtcGFpcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztnQkNBQTtJQUF5Qjs7Ozs7O0lDQXpCO2dCQUFBO2dCQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/app/inputs/form/field-pair/field-pair.component.ngfactory.ts